import React from "react";
import SEO from "../../components/SEO/SEO";
import PlatformHero from "./components/PlatformHero";
import {
  PlatformAvailabilityAndPayment,
  PlatformBookingsAndUpdates,
  PlatformCore,
  PlatformSearch,
  PlatformTrust,
} from "./components/PlatformFeatures";
import { PlatformEcosystem, PlatformJourney, PlatformPartners, PlatformSecurity } from "./components/PlatformPartners";
import { PlatformCta, PlatformFeatureGrid, PlatformFoundation } from "./components/PlatformSummary";

export default function PlatformLandingScreen() {
  return (
    <div className="platform-landing-container flex min-h-screen flex-col">
      <SEO
        title="One Platform. Every Space. - The SPACIA Platform"
        description="Every space on SPACIA under Work, Stay or Play is supported by the same underlying platform: unified search, real-time availability, secure payments and one place to manage every booking."
      />

      <PlatformHero />
      <PlatformCore />
      <PlatformSearch />
      <PlatformAvailabilityAndPayment />
      <PlatformTrust />
      <PlatformBookingsAndUpdates />
      <PlatformJourney />
      <PlatformPartners />
      <PlatformSecurity />
      <PlatformEcosystem />
      <PlatformFoundation />
      <PlatformFeatureGrid />
      <PlatformCta />
    </div>
  );
}
